import {
  type SourceMappingBuildContext,
  type SourceMappingOptionGroup,
  type MappingOption,
} from '../types'

export const buildOrganizationalCategoryOptions = (
  context: SourceMappingBuildContext
): SourceMappingOptionGroup | null => {
  const { translatedLabels } = context

  const options: MappingOption[] = [
    {
      label: translatedLabels.singularPrimaryOrgCategoryLabel,
      value: 'location',
      type: 'native',
      active: true,
    },
    {
      label: translatedLabels.singularSecondaryOrgCategoryLabel,
      value: 'department',
      type: 'native',
      active: true,
    },
  ]

  return {
    options,
  }
}
